<!-- Universal Pager Component -->

<template>
	<div class="pager-main">

		<div class="title">
			<div class="title-left">
				Stories Found: {{pager.totRecs}}
			</div>
			<div class="title-right" v-if="pager.totRecs > pager.recsPerPage">
				Stories: {{pager.begRec}} - {{pager.endRec}}
			</div>
		</div>

		<div class="content" v-if="pager.totRecs > pager.recsPerPage">

			<button
				v-for="(btn, idx) in btns" :key="idx" 
				:class="btn.class"
				:style="'float:' + btn.float"
				@click="goClickPage(btn)"
			>
				{{btn.label}}
			</button>

		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex'
export default {
	data() {
		return {
			btns: [],
			begNum: 0,
			qtyBtns: 0,
		}
	},
	computed: {
		...mapState('app', ['pager']),
	},
	watch: {
		pager: {
			handler: function(newValue, oldValue) {
				m("pager is now", newValue);
				this.calcButtons();
			},
			deep:true, // Deep watcher!
		}
	},
	methods: {
		goClickPage(btn) {
			m("goClickPage LEFT OFF HERE", btn.pageNum);
			document.activeElement.blur();
			this.$store.dispatch("app/setPager", { curPage: btn.pageNum } )
				.then( (res) => {this.$store.dispatch('app/reqArticles')}
			)
			// LEFT OFF HERE
		},

		calcButtons() {
			m("calc buttons");

			this.btns = [];

			let totPages = this.pager.totRecs / this.pager.recsPerPage;
			if (totPages %1 >0) totPages = Math.floor(totPages + 1);
			m("totPages", totPages);

			let curSet = Math.floor((this.pager.curPage -.5)/ this.pager.btnsPerSet);
			this.begNum = curSet * this.pager.btnsPerSet + 1;
			m("begNum", this.begNum);

			let n = totPages - this.begNum + 1;
			this.qtyBtns = Math.min(n, this.pager.btnsPerSet);
			m("qtyBtns", this.qtyBtns);

			// First Page
			this.btns.push({
				label: "<<",
				pageNum: 1,
				float: "left",
				class: (this.pager.curPage==1)? "btn active": "btn",
			});

			// Prev Page
			this.btns.push({
				label: "<",
				pageNum: Math.max(this.pager.curPage - 1, 1),
				float: "left",
				class: (this.pager.curPage==1)? "btn active": "btn",
			});

			for (let i=this.begNum; i<this.begNum + this.qtyBtns; i++) {
				this.btns.push({
					label: i,
					pageNum: i,
					float: "left",
				class: (this.pager.curPage==i)? "btn active": "btn",
				});
			}

			// Last Page
			this.btns.push({
				label: ">>",
				pageNum: totPages,
				float: "right",
				class: (this.pager.curPage==totPages)? "btn active": "btn",
			});

			// Next Page
			this.btns.push({
				label: ">",
				pageNum: Math.min(this.pager.curPage + 1, totPages),
				float: "right",
				class: (this.pager.curPage==totPages)? "btn active": "btn",
			});

		},
	},
	created() {
		this.calcButtons();
	},
}
</script>

<style scoped>
.pager-main {
	width: 306px;
	height: 70px;
	overflow: hidden;
	margin: auto;
	background-color: #FCFCEE;
	border: solid 0px #369;
}

.title {
	height: 25px;
	overflow: hidden;
	white-space: nowrap;
	border: solid 0px #C30;
}

.title-left {
	float: left;
	width: 150px;
	overflow: hidden;
	white-space: nowrap;
	border: solid 0px #000;
}

.title-right {
	float: right;
	width: 150px;
	overflow: hidden;
	white-space: nowrap;
	text-align: right;
	border: solid 0px #090;
}

.content {
	height: 40px;
	overflow: hidden;
	white-space: nowrap;
	border: solid 0px #900;
}

.btn {
	width:34px;
	height: 34px;
	text-align:center;
	cursor: pointer;
	font-weight: normal;
	padding: 0px 0px 0px 0px;
	border-top: solid 2px #DDD;
	border-left: solid 2px #DDD;
	border-radius: 4px;
}

.active {
	color: #FFF;
	border-top: solid 1px #EEE;
	border-left: solid 1px #EEE;
	padding: 1px 0px 0px 0px;
	background-color: #090;
}

</style>
